export const pagePreviews = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/t3k3Kbop3V9xQb3AfzFY7v/WhatsApp_Image_2026-09-10_at_5.05.30_PM.jpg',
    caption: 'Agentes: los certificados por FIFA y los que no lo están',
    alt: 'Página del PDF que compara agentes certificados por FIFA, intermediarios no certificados y operadores sin licencia',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fmY6kZnGompewaQB27tTMU/WhatsApp_Image_2026-09-10_at_5.05.31_PM_(1).jpg',
    caption: '¿Qué debe tener un contrato válido? Punto por punto',
    alt: 'Página del PDF que detalla los ocho elementos obligatorios de un contrato de formación válido',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3QRXLibJtSDKbqTEXodtGE/WhatsApp_Image_2026-09-10_at_5.05.30_PM_(1).jpg',
    caption: 'Las 5 presiones psicológicas y cómo responderlas',
    alt: 'Página del PDF con una tabla de las cinco presiones psicológicas más sutiles y su contraargumento',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kGkNDkvm8o1fTu9a28uUhE/WhatsApp_Image_2026-09-10_at_5.05.30_PM_(2).jpg',
    caption: 'Psicología del entorno — acompañar sin presionar',
    alt: 'Página del PDF sobre psicología del entorno familiar y el síndrome del padre presionador',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7gJc2utjQ6hJTDCCCZemy7/WhatsApp_Image_2026-09-10_at_5.05.31_PM_(2).jpg',
    caption: 'Las 4 fases de la nutrición en el futbol',
    alt: 'Página del PDF con las cuatro fases de nutrición antes, durante y después del entrenamiento',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fURY2qxiozVQUic8cVuzzX/WhatsApp_Image_2026-09-10_at_5.05.31_PM_(3).jpg',
    caption: 'Los 3 macronutrientes — la fórmula por kilo de peso',
    alt: 'Página del PDF que explica proteína, carbohidratos y grasas con gramos por kilo de peso corporal',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kwPzNZzCcqg9KKAPB495oU/WhatsApp_Image_2026-09-10_at_5.05.31_PM.jpg',
    caption: 'Checklist de acción inmediata — qué hacer en los próximos 7 días',
    alt: 'Página del PDF con el checklist de acción inmediata de cinco pasos para la primera semana',
  },
]
